export default {
  newDesign: true,
  title: "Çocuğunuz 2026 LGS'ye hazır mı? | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrQLgs",
    segment: 52,
    fb_pixel: 1272902257531593,
  },
  startPage: {
    title:
      "Çocuğunuz 2026 LGS'ye hazır mı?",
    subtitle:
      "5 hızlı soruyu cevaplayın ve çocuğunuzun güçlü ve zayıf yönlerini ortaya koyan bir ücretsiz deneme dersi alın — LGS öncesi güvenlerini artırmalarına yardımcı olun!",
    image: {
      url: "/welcome/tr_lgs3_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/tr_lgs3_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " 1 dakikalık quiz'e başlayın ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz şu anda kaçıncı sınıfta?",
      answers: [
        "🌟 6. sınıf (gelecek yıl 7. sınıf olacak)",
        "🎒 7. sınıf (gelecek yıl 8. sınıf olacak)",
        "📚 8. sınıf (bu yıl LGS’ye giriyor)",
        "🌈 Diğer"
      ],
    },
    2: {
      question: "Çocuğunuz LGS sınavı hakkında ne düşünüyor?",
      answers: [
        "😊 Kendine güveniyor ve motive",
        "🙂 Biraz endişeli ama çabalıyor",
        "😟 Stresli veya korkuyor",
        "🤫 Bu konu hakkında çok konuşmuyor"
      ],
    },
    3: {
      question: "LGS’nin çocuğunuz için en korkutucu kısmı nedir?",
      answers: [
        "⏰ Zaman baskısı ve stres",
        "🤔 Soruları tam anlayamamak",
        "🧮 Özellikle matematik soruları",
        "😞 Başarısız olma düşüncesi",
        "🙉 Bu konuyu hiç konuşmadık"
      ],
    },
    4: {
      question: "Çocuğunuzun şu anki Matematik ve Fen notları nedir?",
      answers: [
        "🌟 85–100",
        "🌻 70–84",
        "🍀 60–69",
        "💔 60’ın altında"
      ],
    },
    5: {
      question: "Sizce çocuğunuz LGS’ye hazır mı?",
      answers: [
        "💯 Evet, %100 hazır",
        "💪 Neredeyse hazır ama pratik yapması gerek",
        "🤔 Pek hazır değil — ciddi hazırlık gerekiyor",
        "🤷‍♂️ Emin değilim"
      ],
    },
    6: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayir",
          stopAnswer: true,
        },
      ],
    },
    7: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz.",
      type: "age",
      button: "",
    },
    8: {
      title: "Tebrikler! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Kaydı tamamlamak için '📆 Rezervasyon yapın' seçeneğine tıklayın.",
      button: "📆 Rezervasyon yapın",
    },
    9: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    10: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    11: {
      title:
        "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    12: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    13: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};
